import { useRef, useState, useEffect } from "react";
import axios from "axios";
import style from "../css/AdminModal.module.css";
import exit from "../img/component/admin_exit.svg";

export default function AdminProduction({ setShowAdmin, field, setRender }) {
    const [getData, setGetData] = useState([]);
    const [dataNum, setDataNum] = useState(null);
    const [selectItem, setSelectItem] = useState();
    const itemRef = useRef([]);
    const inputRef = useRef();
    const [imageSrc, setImageSrc] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const columnK = {
        album: "앨범",
        drama: "드라마",
        concert: "콘서트",
        movie: "영화",
        producer: "프로듀서"
    }

    useEffect(() => {
        axios.get(process.env.REACT_APP_SERVER + '/api/data/production')
            .then((Response) => {
                if(Response.data.data.length !== 0) {
                    setGetData(Response.data.data[field]);
                    if(Response.data.data[field].length !== 0) {
                        setDataNum(0);
                        setSelectItem(Response.data.data[field][0].id);
                        setImageSrc(Response.data.data[field][0].imgUrl)
                    }
                }
            })
            .catch((Error) => {
                console.log(Error)
            })
    }, [])

    function closeAdmin() {
        setRender(new Date());
        setShowAdmin(false);
    }

    function deleteItem(e, idx) {
        e.stopPropagation();
        if(selectItem === "") {
            if(window.confirm("프로듀서 추가를 취소하시겠습니까?")) {
                setGetData(getData.filter(data => data.id !== ""))
                setSelectItem(getData.filter(data => data.id !== "")[0].id);
                itemRef.current[0].value = getData.filter(data => data.id !== "")[0]['department'];
                itemRef.current[1].value = getData.filter(data => data.id !== "")[0]['enDepartment'];
                itemRef.current[2].value = getData.filter(data => data.id !== "")[0]['name'];
                itemRef.current[3].value = getData.filter(data => data.id !== "")[0]['enName'];
                itemRef.current[4].value = getData.filter(data => data.id !== "")[0]['work'];
                itemRef.current[5].value = getData.filter(data => data.id !== "")[0]['enWork'];
                setImageSrc(getData.filter(data => data.id !== "")[0]['imgUrl']);
            }
            return
        }
        if(window.confirm("정말 삭제하시겠습니까?")) {
            axios.delete(process.env.REACT_APP_SERVER + '/api/admin/delete/production', { data: {id: idx, column: field, imgUrl: getData.filter(data => data.id ===idx)[0]['imgUrl']}, withCredentials: true, })
            .then((Response) => {
                if(Response.data.state === "success") {
                    const newData = getData.filter(data => data.id !== idx);
                    setGetData(newData);
                    if(newData.length !== 0) {
                        setDataNum(0);
                        setSelectItem(newData[0].id);
                        itemRef.current[0].value = newData[0]['department'];
                        itemRef.current[1].value = newData[0]['enDepartment'];
                        itemRef.current[2].value = newData[0]['name'];
                        itemRef.current[3].value = newData[0]['enName'];
                        itemRef.current[4].value = newData[0]['work'];
                        itemRef.current[5].value = newData[0]['enWork'];
                        setImageSrc(newData[0]['imgUrl']);
                    } else {
                        itemRef.current[0].value = "";
                        itemRef.current[1].value = "";
                        itemRef.current[2].value = "";
                        itemRef.current[3].value = "";
                        itemRef.current[4].value = "";
                        itemRef.current[5].value = "";
                        setImageSrc(null);
                    }
                    alert("삭제가 완료되었습니다.");
                }
            })
            .catch((Error) => {
                console.log(Error)
            })
        }
    }

    function changeTarget(dataId, idx) {
        if(selectItem === "") {
            if(idx === 0 && selectItem === "") {
                return
            }
            if(window.confirm("변경된 정보를 저장하시겠습니까?")) {
                addItem()
                return
            } else {
                setGetData(getData.filter(data => data.id !== ""))
                setSelectItem(dataId);
                setDataNum(idx-1);
                itemRef.current[0].value = getData.filter(data => data.id !== "")[0]['department'];
                itemRef.current[1].value = getData.filter(data => data.id !== "")[0]['enDepartment'];
                itemRef.current[2].value = getData.filter(data => data.id !== "")[0]['name'];
                itemRef.current[3].value = getData.filter(data => data.id !== "")[0]['enName'];
                itemRef.current[4].value = getData.filter(data => data.id !== "")[0]['work'];
                itemRef.current[5].value = getData.filter(data => data.id !== "")[0]['enWork'];
                setImageSrc(getData.filter(data => data.id !== "")[0]['imgUrl']);
                return
            }
        }

        if( getData[dataNum].department === itemRef.current[0].value &&
            getData[dataNum].enDepartment === itemRef.current[1].value &&
            getData[dataNum].name === itemRef.current[2].value &&
            getData[dataNum].enName === itemRef.current[3].value &&
            getData[dataNum].work === itemRef.current[4].value &&
            getData[dataNum].enWork === itemRef.current[5].value &&
            getData[dataNum].imgUrl === imageSrc) {
                setSelectItem(dataId);
                setDataNum(idx);
            } else {
                if(window.confirm("변경된 정보를 저장하시겠습니까?")) {
                    const newData = {
                        id: selectItem,
                        column: field,
                        department: itemRef.current[0].value.replaceAll('\'', '\\\''),
                        enDepartment : itemRef.current[1].value.replaceAll('\'', '\\\''),
                        name : itemRef.current[2].value,
                        enName: itemRef.current[3].value,
                        work: itemRef.current[4].value.replaceAll('\'', '\\\''),
                        enWork: itemRef.current[5].value.replaceAll('\'', '\\\''),
                        beforeImgUrl: getData[dataNum].imgUrl
                    }
                    const formData = new FormData();
                    formData.set('file', imageFile);
                    formData.set('data', JSON.stringify(newData));
                    axios({
                        method: "put",
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        url: process.env.REACT_APP_SERVER + "/api/admin/put/production",
                        data: formData,
                    })
                    .then((Response) => {
                        if(Response.data.state === "success") {
                            const newGetData = [...getData];
                            newGetData[dataNum] = {
                                id: newData.id,
                                department: newData.department,
                                enDepartment: newData.enDepartment,
                                name: newData.name,
                                enName: newData.enName,
                                work: newData.work,
                                enWork: newData.enWork,
                                imgUrl: Response.data.imgUrl
                            }
                            setGetData(newGetData)
                            alert("저장되었습니다.")
                        }
                    })
                }
                setSelectItem(dataId);
                setDataNum(idx);
            }
    }

    function createItem() {
        if(selectItem === "") {
            alert("현재 입력중인 데이터가 있습니다.");
            return
        }
        const addData = {
            id: "",
            department: "",
            enDepartment: "",
            name: "",
            enName: "",
            work: "",
            enWork: "",
            imgUrl: ""
        }
        setGetData([addData, ...getData]);
        setDataNum(0);
        setSelectItem("");
        setImageSrc(null);
        itemRef.current[0].value = ""
        itemRef.current[1].value = ""
        itemRef.current[2].value = ""
        itemRef.current[3].value = ""
        itemRef.current[4].value = ""
        itemRef.current[5].value = ""
        inputRef.current.value = null;
    }

    function addItem() {
        if(itemRef.current[0].value !== "" && itemRef.current[1].value !== "" && itemRef.current[2].value !== "" && itemRef.current[3].value !== "" && imageSrc !== null) {
            if(selectItem !== "") {
                if(window.confirm("변경된 정보를 저장하시겠습니까?")) {
                    const newData = {
                        id: selectItem,
                        column: field,
                        department: itemRef.current[0].value.replaceAll('\'', '\\\''),
                        enDepartment : itemRef.current[1].value.replaceAll('\'', '\\\''),
                        name : itemRef.current[2].value,
                        enName: itemRef.current[3].value,
                        work: itemRef.current[4].value.replaceAll('\'', '\\\''),
                        enWork: itemRef.current[5].value.replaceAll('\'', '\\\''),
                        beforeImgUrl: getData[dataNum].imgUrl
                    }
                    const formData = new FormData();
                    formData.set('file', imageFile);
                    formData.set('data', JSON.stringify(newData));

                    axios({
                        method: "put",
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        url: process.env.REACT_APP_SERVER + "/api/admin/put/production",
                        data: formData,
                    })
                    .then((Response) => {
                        if(Response.data.state === "success") {
                            const newGetData = [...getData];
                            newGetData[dataNum] = {
                                id: newData.id,
                                department: newData.department,
                                enDepartment: newData.enDepartment,
                                name: newData.name,
                                enName: newData.enName,
                                work: newData.work,
                                enWork: newData.enWork,
                                imgUrl: Response.data.imgUrl
                            }
                            setGetData(newGetData)
                            setImageSrc(Response.data.imgUrl);
                            alert("저장되었습니다.")
                        }
                    })
                }
            } else {
                const data = JSON.stringify({
                    name: field,
                    department: itemRef.current[0].value.replaceAll('\'', '\\\''),
                    enDepartment : itemRef.current[1].value.replaceAll('\'', '\\\''),
                    kname: itemRef.current[2].value,
                    enName: itemRef.current[3].value,
                    work: itemRef.current[4].value.replaceAll('\'', '\\\''),
                    enWork: itemRef.current[5].value.replaceAll('\'', '\\\''),
                })

                const formData = new FormData();
                formData.set('file', imageFile);
                formData.set('data', data);

                axios({
                    method: "post",
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: process.env.REACT_APP_SERVER + "/api/admin/add/production",
                    data: formData,
                })
                .then((Response) => {
                    if(Response.data.state === "success") {
                        axios.get(process.env.REACT_APP_SERVER + '/api/data/production')
                        .then((Response2) => {
                            setGetData(Response2.data.data[field]);
                            if(Response2.data.data[field].length !== 0) {
                                setSelectItem(Response2.data.data[field][0].id);
                                setImageSrc(Response2.data.data[field][0].imgUrl);
                                setDataNum(0);
                                itemRef.current[0].value = Response2.data.data[field][0]['department'];
                                itemRef.current[1].value = Response2.data.data[field][0]['enDepartment'];
                                itemRef.current[2].value = Response2.data.data[field][0]['name'];
                                itemRef.current[3].value = Response2.data.data[field][0]['enName'];
                                itemRef.current[4].value = Response2.data.data[field][0]['work'];
                                itemRef.current[5].value = Response2.data.data[field][0]['enWork'];
                            }
                            setImageFile(null);
                            inputRef.current.value = null;
                            alert("추가가 완료되었습니다.");
                        })
                        .catch((Error) => {
                            console.log(Error)
                        })
                    } else {
                        alert(Response.data.message);
                    }
                })
                .catch((Error) => {
                    console.log(Error);
                })
                return
            }
        } else {
            alert("필수항목을 입력해주시기 바랍니다.")
            return
        }
    }

    function onUploadImage(e) {
        if (e.target.value.length === 0) {
            return;
        } else if(e.target.files[0].size > e.target.size) {
            alert("파일 용량이 10MB를 초과합니다.");
            return
        } else {
            let reader = new FileReader();

            if(e.target.files[0]) {
                reader.readAsDataURL(e.target.files[0]);
                setImageFile(e.target.files[0]);
            }

            reader.onloadend = function() {
                setImageSrc(reader.result);
            }
        }
    };

    function previewImage() {
        if (!inputRef.current) {
            return;
        }
        inputRef.current.click();
    }

    useEffect(() => {
        if(getData.length !== 0) {
            itemRef.current[0].value = getData[dataNum]['department'];
            itemRef.current[1].value = getData[dataNum]['enDepartment'];
            itemRef.current[2].value = getData[dataNum]['name'];
            itemRef.current[3].value = getData[dataNum]['enName'];
            itemRef.current[4].value = getData[dataNum]['work'];
            itemRef.current[5].value = getData[dataNum]['enWork'];
            setImageSrc(getData[dataNum]['imgUrl']);
        }
    }, [dataNum])

    return (
     <div className={ `${style.container} ${style.production}` }>
            <div className={ style.topContainer }>
                <span>{ columnK[field] + " 관리" }</span>
                <img src={ exit } alt="exit" onClick={ closeAdmin }></img>
            </div>
            <div className={ style.middleContainer }>
                <div className={ style.middleProductionWrap }>
                    <div className={ style.middleProduction }>
                        <div className={ style.themeContainer }>
                            <span className={ style.middleTheme }>{ columnK[field] + " 목록" }</span>
                            <hr className={ style.middleLine }></hr>
                        </div>
                        <div className={ style.productionContent }>
                            <div className={ style.productionListContainer }>
                                {
                                    getData.map((data, idx) => (
                                        <div key={ data.id } className={ dataNum === idx ? `${style.productionListItem} ${style.selected}` : style.productionListItem } onClick={ () => changeTarget(data.id, idx) }>
                                            <div className={ style.productionListItemNum }>
                                                <span>{idx+1}</span>
                                            </div>
                                            <div className={ style.productionListItemName }>
                                                <span>{data.name}</span>
                                            </div>
                                            <div className={ style.deleteItemBtn } onClick={ (e) => deleteItem(e, data.id) }>
                                                <div>
                                                    <hr></hr>
                                                    <hr></hr>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={ `${style.actionButton2} ${style.fncProductionBtn}` } onClick={ createItem }>
                                { columnK[field] + " 추가"}
                            </div>
                        </div>
                    </div>
                    <div className={ style.middleProduction }>
                        <div className={ style.themeContainer }>
                            <span className={ style.middleTheme }>{ columnK[field] + " 등록/수정" }</span>
                            <hr className={ style.middleLine }></hr>
                        </div>
                        <div className={ style.productionContent3 }>
                            <div className= { style.productionContentImage }>
                                <div className={ style.contentImageContainer2 }>
                                    <span className={ style.productionContentTheme2 } >{ columnK[field] + " 이미지"}<span className={ style.required }>*필수</span></span>
                                    <span className={ style.productionContentMent }>- 10mb 미만의 이미지만 업로드할 수 있습니다.</span>
                                    <span className={ style.productionContentMent }>- 160x160px 이상의 이미지 업로드를 권장합니다. (1:1 비율)</span>
                                </div>
                                <div className={ style.infoImage }>
                                    <div className={ field === "album" ? `${style.producerImage} ${style.isalbum}` : style.producerImage }>
                                        {
                                            imageSrc && <img src={ imageSrc } alt="previewImage" onClick={ previewImage }></img>
                                        }
                                        <div className={ style.producerPlus } onClick={ previewImage }>
                                            <hr className={ style.plusShape }></hr>
                                            <hr className={ style.plusShape }></hr>
                                        </div>
                                        <input type="file" accept="image/*" ref={ inputRef } onChange={ onUploadImage } size="10485760"></input>
                                    </div>
                                </div>
                            </div>
                            <div className={ style.productionContentInfo2 }>
                                <div className={ style.contentInfoContainer }>
                                    <span className={ style.productionContentTheme } >{ columnK[field] + " 정보"}</span>
                                </div>
                                <div className={ style.infoItemContainer }>
                                    <div className={ style.infoItem }>
                                        <span>한글직책<span className={ style.required }>*필수</span></span>
                                        <input type="text" ref={ el => (itemRef.current[0] = el) }></input>
                                    </div>
                                    <div className={ style.infoItem }>
                                        <span>영문직책<span className={ style.required }>*필수</span></span>
                                        <input type="text" ref={ el => (itemRef.current[1] = el) }></input>
                                    </div>
                                    <div className={ style.infoItem }>
                                        <span>한글이름<span className={ style.required }>*필수</span></span>
                                        <input type="text" ref={ el => (itemRef.current[2] = el) }></input>
                                    </div>
                                    <div className={ style.infoItem }>
                                        <span>영문이름<span className={ style.required }>*필수</span></span>
                                        <input type="text" ref={ el => (itemRef.current[3] = el) }></input>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className={style.producerContentInfo}>
                                <div className={ style.contentInfoContainer }>
                                    <span className={ style.productionContentTheme } >이력사항</span>
                                    <span className={ style.productionContentMent2 }>- 좌측은 국문, 우측은 영문 버전에 보이는 이력사항입니다.</span>
                                    <span className={ style.productionContentMent2 }>- 각 항목당 최대 글자 수는 공백 포함 1,000자입니다.</span>
                                    <span className={ style.productionContentMent2 }>- 각 항목은 ‘,’ 컴마로 구분됩니다.</span>
                                </div>
                                <div className={style.producerTextContainer}>
                                    <div className={style.producerItem}>
                                        <span>작품</span>
                                        <textarea ref={ el => (itemRef.current[4] = el) } maxLength="1000"></textarea>
                                    </div>
                                    <div className={style.producerItem}>
                                        <span>Work</span>
                                        <textarea ref={ el => (itemRef.current[5] = el) } maxLength="1000"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ style.bottomContainer }>
                <div className={ style.actionButton } onClick={ addItem }>
                    <span>저장하기</span>
                </div>
            </div>
        </div>
    )
}